// ------------------------------------
// props 輸入需求 :
// props.isON : boolean                                             ( 元件開關 )
// props.date : obj ( obj new Date)() )                             ( 傳入當天日期 )
// ------------------------------------

import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Account from '../../../../actions/Account';
import { ADD_HIS_DATE, ADD_TIME_END, ADD_TIME_START } from '../../../../stores/reducer_HistoryData';

const TAIPEI_OFFSET_MS = 8 * 60 * 60 * 1000;

const DateCalander = (props) => {
  const { t } = useTranslation();
  const [dayMonth, setDayMonth] = useState('');
  const [isOpenCalander, setIsOpenCalander] = useState(false);

  const store_timestamp = useSelector((state) => state.store_historyData.timestamp);
  const [date, setDate] = useState(new Date());
  const dispatch = useDispatch();

  const handleChange = (e) => {
    try {
      e.getDate();
      setIsOpenCalander(!isOpenCalander);

      const year = e.getFullYear();
      const month = e.getMonth() + 1;
      const day = e.getDate();

      // 台灣當天 00:00（固定用台北時區，不吃系統時區）
      const taipeiMidnight =
        Date.UTC(year, month - 1, day, 0, 0, 0, 0) - TAIPEI_OFFSET_MS;

      // 顯示用日期固定為你選到的那一天
      setDayMonth(`${month}/${day}`);
      setDate(new Date(year, month - 1, day));

      // 這裡保留原本邏輯，避免影響原始數據查詢
      dispatch(ADD_HIS_DATE(e.getTime()));

      // 時間區間固定為：前一天 20:00 ～ 當天 08:00
      dispatch(ADD_TIME_START(taipeiMidnight - 4 * 60 * 60 * 1000));
      dispatch(ADD_TIME_END(taipeiMidnight + 8 * 60 * 60 * 1000));
    } catch {
      setIsOpenCalander(!isOpenCalander);
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    setIsOpenCalander(!isOpenCalander);
  };

  useEffect(() => {
    if (store_timestamp !== '') {
      const d = new Date(store_timestamp); // ❗ 改這裡（拿掉 +8）

      const y = d.getFullYear();
      const m = d.getMonth() + 1;
      const day = d.getDate();

      setDayMonth(`${m}/${day}`);
      setDate(new Date(y, m - 1, day));
    }
  }, [store_timestamp]);

  if (Account.isMobileOrTablet()) {
    return (
      <div className={`${Account.isMobile() ? 'littleUi' : 'col-4'} fx-ccc`}>
        {props.isON ? (
          <div className="top-tag fx-d-c fx-ccc">
            <div className="name m fx-ccc">{t('GLOBAL.DATE')}</div>
            <div className="fx-ccc">
              <div className="" onClick={handleClick}>
                {dayMonth}
              </div>
              {isOpenCalander && (
                <div
                  className="pos-f z-1 wid-full hig-full top-0 left-0 cursor-def"
                  onClick={handleChange}
                >
                  <div
                    className="pos-a z-1 calander m"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <DatePicker
                      selected={date}
                      onChange={handleChange}
                      inline
                      maxDate={new Date()}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="col-4 fx-ccc ">
      {props.isON ? (
        <div className="top-tag fx-d-r ">
          <div className="name fx-ccc">{t('GLOBAL.DATE')}</div>
          <div className="body h-50">
            <div className="inner" onClick={handleClick}>
              {dayMonth}
            </div>
            {isOpenCalander && (
              <div
                className="pos-f z-max wid-full hig-full top-0 left-0 cursor-def"
                onClick={handleChange}
              >
                <div
                  className="pos-a z-3 calander "
                  onClick={(e) => e.stopPropagation()}
                >
                  <DatePicker
                    selected={date}
                    onChange={handleChange}
                    inline
                    maxDate={new Date()}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DateCalander;